import { useEffect } from 'react';
import { App } from 'antd';
import { useMsal } from '@azure/msal-react';
import { consumeInviteSignupFlag } from '../utils/inviteSignup';

const InviteSignupNotice = () => {
  const { message } = App.useApp();
  const { accounts } = useMsal();

  useEffect(() => {
    if (!accounts || accounts.length === 0) {
      return;
    }
    if (!consumeInviteSignupFlag()) {
      return;
    }
    message.success('Account created successfully. You are all set.');
  }, [accounts, message]);

  return null;
};

export default InviteSignupNotice;
